/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _circle, _circle2, _circle3, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _circle4, _path124, _circle5, _path125, _path126, _circle6, _path127, _path128, _path129, _path130, _path131, _path132, _circle7, _circle8, _circle9, _circle0, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _circle1, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _circle10, _circle11, _path176, _circle12, _circle13, _path177, _path178, _circle14, _circle15, _path179, _path180, _circle16, _circle17, _path181, _path182, _circle18, _circle19, _path183, _path184, _circle20, _circle21, _path185, _path186, _circle22, _circle23, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _rect, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _circle24, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _circle25, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _circle26, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _circle27, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _path422, _path423, _path424, _path425, _path426;
const SatisfyUsage = /*#__PURE__*/React.forwardRef(function SatisfyUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.3934,19.5537c0-1.8433,1.3953-2.7563,3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337,0-1.6194.5168-2.05,1.137l-1.3093-1.1714c.6545-1.0337,1.7056-1.7228,3.5144-1.7228,2.429,0,3.7209,1.1543,3.7209,3.2042v4.2379h.896v1.7572h-1.2231c-.9475,0-1.5332-.6201-1.6711-1.5504h-.1033c-.293,1.1542-1.2749,1.7572-2.6187,1.7572-1.8259,0-2.8596-1.0509-2.8596-2.6531Zm5.3624-.2412v-1.1886h-1.4126c-1.1541,0-1.7227.3962-1.7227,1.1025v.2928c0,.7235.4995,1.0853,1.3608,1.0853.9819,0,1.7744-.4479,1.7744-1.2921Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m6.6184,20.2084l1.5332-1.4816c.8269.9647,1.8433,1.4816,3.0837,1.4816,1.3953,0,2.1189-.6719,2.1189-1.6882,0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971,0-2.1534,1.6709-3.5488,4.3584-3.5488,1.8088,0,3.1526.6202,4.1172,1.7744l-1.5503,1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292,0-1.9639.5168-1.9639,1.4126,0,.9131.5168,1.292,1.6711,1.4988l1.1196.2067c2.429.4308,3.5662,1.516,3.5662,3.4972,0,2.2739-1.6367,3.8245-4.5137,3.8245-2.05,0-3.4626-.8097-4.479-1.9984Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SatisfyUsage.propTypes = iconPropTypes;
}
const Save = /*#__PURE__*/React.forwardRef(function Save({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
      d: "M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5 C14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1 h4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
      d: "M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1 C18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3 c0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4 L14,16.7L14,16.7z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
      d: "M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12 C21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6 h-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Save.propTypes = iconPropTypes;
}
const WatsonHealthSaveAnnotation = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveAnnotation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H26V8H20z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H26V12H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSaveAnnotation.propTypes = iconPropTypes;
}
const WatsonHealthSaveImage = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveImage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSaveImage.propTypes = iconPropTypes;
}
const SaveModel = /*#__PURE__*/React.forwardRef(function SaveModel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SaveModel.propTypes = iconPropTypes;
}
const WatsonHealthSaveSeries = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveSeries({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSaveSeries.propTypes = iconPropTypes;
}
const Scale = /*#__PURE__*/React.forwardRef(function Scale({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Scale.propTypes = iconPropTypes;
}
const Scales = /*#__PURE__*/React.forwardRef(function Scales({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Scales.propTypes = iconPropTypes;
}
const ScalesTipped = /*#__PURE__*/React.forwardRef(function ScalesTipped({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScalesTipped.propTypes = iconPropTypes;
}
const Scalpel = /*#__PURE__*/React.forwardRef(function Scalpel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Scalpel.propTypes = iconPropTypes;
}
const WatsonHealthScalpelCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,7.1338a4.0941,4.0941,0,0,0-5.6562,0L.3433,29.9619H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.79a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8406l2.086-2.0858,2.8293,2.8293L15.1224,23.67ZM11.71,27.083a2.9824,2.9824,0,0,1-2.1215.8789H5.1714l5.7073-5.7072,2.83,2.83ZM27.4141,11.376,18.6221,20.17l-2.8293-2.8292,8.7931-8.7928a2.0471,2.0471,0,0,1,2.8282,0,1.9993,1.9993,0,0,1,0,2.8281Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthScalpelCursor.propTypes = iconPropTypes;
}
const WatsonHealthScalpelLasso = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelLasso({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,7.1338a4.0941,4.0941,0,0,0-5.6562,0L.3433,29.9619H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.79a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8406l2.086-2.0858,2.8293,2.8293L15.1224,23.67ZM11.71,27.083a2.9824,2.9824,0,0,1-2.1215.8789H5.1714l5.7073-5.7072,2.83,2.83ZM27.4141,11.376,18.6221,20.17l-2.8293-2.8292,8.7931-8.7928a2.0471,2.0471,0,0,1,2.8282,0,1.9993,1.9993,0,0,1,0,2.8281Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11,2H7a4.9843,4.9843,0,0,0-3.8633,8.1528A2.9586,2.9586,0,0,0,3,11a2.9945,2.9945,0,0,0,2,2.8154V14a2.0025,2.0025,0,0,1-2,2H2v2H3a4.0045,4.0045,0,0,0,4-4v-.1841A2.9959,2.9959,0,0,0,8.8157,12H11A5,5,0,0,0,11,2ZM6,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,12Zm5-2H8.8157A2.974,2.974,0,0,0,4.394,8.4746,2.9908,2.9908,0,0,1,7,4h4a3,3,0,0,1,0,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthScalpelLasso.propTypes = iconPropTypes;
}
const WatsonHealthScalpelSelect = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelSelect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,7.1719a4.0941,4.0941,0,0,0-5.6562,0L.3433,30H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.8281a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8787l2.086-2.0859,2.8293,2.8294-2.0857,2.0862ZM11.71,27.1211A2.9824,2.9824,0,0,1,9.5889,28H5.1714l5.7073-5.7072,2.83,2.83Zm15.7037-15.707-8.792,8.7939-2.8293-2.8292,8.7931-8.7929a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15,2a2.9948,2.9948,0,0,0-2.8157,2H7.8156A2.9925,2.9925,0,1,0,4,7.8154v4.3687a3,3,0,1,0,2,0V7.8159A2.9959,2.9959,0,0,0,7.8156,6h4.3686A2.9947,2.9947,0,1,0,15,2ZM5,16a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,5,16ZM5,6A1,1,0,1,1,6,5,1.0008,1.0008,0,0,1,5,6ZM15,6a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,15,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthScalpelSelect.propTypes = iconPropTypes;
}
const Scan = /*#__PURE__*/React.forwardRef(function Scan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H17V23H15z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9H29V23H27z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H23V23H21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Scan.propTypes = iconPropTypes;
}
const ScanAlt = /*#__PURE__*/React.forwardRef(function ScanAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24H10a2,2,0,0,1-2-2V19h2v3H22V19h2v3A2,2,0,0,1,22,24Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H30V17H2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22V10H10v3H8V10a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10L28 10 28 4 22 4 22 2 30 2 30 10z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10L2 10 2 2 10 2 10 4 4 4 4 10z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30L2 30 2 22 4 22 4 28 10 28 10 30z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScanAlt.propTypes = iconPropTypes;
}
const ScanDisabled = /*#__PURE__*/React.forwardRef(function ScanDisabled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3826,2.0762a.9993.9993,0,0,0-1.09.2168l-26,26A1,1,0,0,0,3,30h8V28H5.4143l4-4H22a2.0021,2.0021,0,0,0,2-2V9.4146l4-4V11h2V3A1,1,0,0,0,29.3826,2.0762ZM22,22H11.4143L22,11.4146Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10,17.7554V10h7.7554l2-2H10a2.0025,2.0025,0,0,0-2,2v9.7554Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23.755L4 21 2 21 2 25.754 4 23.755z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.755 2L21 2 21 4 23.755 4 25.755 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScanDisabled.propTypes = iconPropTypes;
}
const ScatterMatrix = /*#__PURE__*/React.forwardRef(function ScatterMatrix({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "9.5",
    cy: "9.5",
    r: "2.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.5",
    cy: "22.5",
    r: "2.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.5",
    cy: "22.5",
    r: "2.5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScatterMatrix.propTypes = iconPropTypes;
}
const Schematics = /*#__PURE__*/React.forwardRef(function Schematics({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Schematics.propTypes = iconPropTypes;
}
const ScisControlTower = /*#__PURE__*/React.forwardRef(function ScisControlTower({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2 C5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3 c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6 c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1 s0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,23,27,23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScisControlTower.propTypes = iconPropTypes;
}
const ScisTransparentSupply = /*#__PURE__*/React.forwardRef(function ScisTransparentSupply({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H19V19H13v3H11V19a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,16Zm0-4a1,1,0,1,0,1,1A1.0013,1.0013,0,0,0,16,12Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScisTransparentSupply.propTypes = iconPropTypes;
}
const Scooter = /*#__PURE__*/React.forwardRef(function Scooter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,26,28Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,26,22Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24,8H18v2h6a1,1,0,0,1,0,2H21a1,1,0,0,0-.98,1.1963l.9241,4.6211L18.4338,22h-2.69l-2.5723-8.5752A1.988,1.988,0,0,0,11.2559,12H6v2h5.2561l.6,2H7a5.0057,5.0057,0,0,0-5,5v2a1,1,0,0,0,1,1H4a4,4,0,0,0,8,0h7a1,1,0,0,0,.8574-.4854l3-5a1,1,0,0,0,.1231-.7109L22.22,14H24a3,3,0,0,0,0-6ZM8,26a2.0025,2.0025,0,0,1-2-2h4A2.0025,2.0025,0,0,1,8,26ZM4,22V21a3.0033,3.0033,0,0,1,3-3h5.4561l1.2,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Scooter.propTypes = iconPropTypes;
}
const ScooterFront = /*#__PURE__*/React.forwardRef(function ScooterFront({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V28H15z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScooterFront.propTypes = iconPropTypes;
}
const Screen = /*#__PURE__*/React.forwardRef(function Screen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Screen.propTypes = iconPropTypes;
}
const ScreenOff = /*#__PURE__*/React.forwardRef(function ScreenOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScreenOff.propTypes = iconPropTypes;
}
const ScreenMap = /*#__PURE__*/React.forwardRef(function ScreenMap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25H30V27H22z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21H30V23H22z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScreenMap.propTypes = iconPropTypes;
}
const ScreenMapSet = /*#__PURE__*/React.forwardRef(function ScreenMapSet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H31V28H24z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H31V24H24z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScreenMapSet.propTypes = iconPropTypes;
}
const Script = /*#__PURE__*/React.forwardRef(function Script({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Script.propTypes = iconPropTypes;
}
const ScriptReference = /*#__PURE__*/React.forwardRef(function ScriptReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V16H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10A.9092.9092,0,0,0,25.7,9.3ZM18,10V4.4L23.6,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ScriptReference.propTypes = iconPropTypes;
}
const Sdk = /*#__PURE__*/React.forwardRef(function Sdk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23H12V9h4a4.0118,4.0118,0,0,1,4,4v6A4.0118,4.0118,0,0,1,16,23Zm-2-2h2a2.0059,2.0059,0,0,0,2-2V13a2.0059,2.0059,0,0,0-2-2H14Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23H2V21H8V17H4a2.0059,2.0059,0,0,1-2-2V11A2.0059,2.0059,0,0,1,4,9h6v2H4v4H8a2.0059,2.0059,0,0,1,2,2v4A2.0059,2.0059,0,0,1,8,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sdk.propTypes = iconPropTypes;
}
const Search = /*#__PURE__*/React.forwardRef(function Search({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
      d: "M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5 C2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Search.propTypes = iconPropTypes;
}
const SearchAdvanced = /*#__PURE__*/React.forwardRef(function SearchAdvanced({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24,28.5859l-5.9751-5.9751a9.0234,9.0234,0,1,0-1.4141,1.4141L22.5859,30ZM4,17a7,7,0,1,1,7,7A7.0078,7.0078,0,0,1,4,17Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SearchAdvanced.propTypes = iconPropTypes;
}
const SearchLocate = /*#__PURE__*/React.forwardRef(function SearchLocate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.5859l-4.6885-4.6884a8.028,8.028,0,1,0-1.414,1.414L28.5859,30ZM19,25a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,19,25Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H10V14H2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H18V4H2z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H18V9H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SearchLocate.propTypes = iconPropTypes;
}
const SearchLocateMirror = /*#__PURE__*/React.forwardRef(function SearchLocateMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21,28.6l-4.7-4.7c1.1-1.4,1.7-3.1,1.7-4.9c0-4.4-3.6-8-8-8s-8,3.6-8,8s3.6,8,8,8c1.8,0,3.5-0.6,4.9-1.7l4.7,4.7L21,28.6z M10,25c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S13.3,25,10,25z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H30V14H22z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7H30V9H14z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H30V4H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SearchLocateMirror.propTypes = iconPropTypes;
}
const Security = /*#__PURE__*/React.forwardRef(function Security({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Security.propTypes = iconPropTypes;
}
const SecurityServices = /*#__PURE__*/React.forwardRef(function SecurityServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SecurityServices.propTypes = iconPropTypes;
}
const Select_01 = /*#__PURE__*/React.forwardRef(function Select_01({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24,6V8h4v4h2V8a2,2,0,0,0-2-2Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16H8V20H6z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M8,28V24H6v4a2,2,0,0,0,2,2h4V28Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H30V20H28z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H20V30H16z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24v4H24v2h4a2,2,0,0,0,2-2V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Select_01.propTypes = iconPropTypes;
}
const Select_02 = /*#__PURE__*/React.forwardRef(function Select_02({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10ZM8,28H6V26H8Zm20,0H26V26h2ZM26,6h2V8H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Select_02.propTypes = iconPropTypes;
}
const SelectWindow = /*#__PURE__*/React.forwardRef(function SelectWindow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M8,26H4a2.0021,2.0021,0,0,1-2-2V20H4v4H8Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H4V16H2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8H24V4H20V2h4a2.0021,2.0021,0,0,1,2,2Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H16V4H12z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M4,8H2V4A2.0021,2.0021,0,0,1,4,2H8V4H4Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M27,32a.9967.9967,0,0,1-.707-.293l-6.1377-6.1377L16.832,30.5547a1,1,0,0,1-1.79-.2676l-6-20A1,1,0,0,1,10.2871,9.042l20,6a1,1,0,0,1,.2676,1.79l-4.9854,3.3233L31.707,26.293a.9994.9994,0,0,1,0,1.414l-4,4A.9967.9967,0,0,1,27,32Zm0-2.4141L29.5859,27,22.431,19.845l5.2458-3.4978L11.4917,11.4917l4.8555,16.1851L19.845,22.431Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SelectWindow.propTypes = iconPropTypes;
}
const Send = /*#__PURE__*/React.forwardRef(function Send({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Send.propTypes = iconPropTypes;
}
const SendAlt = /*#__PURE__*/React.forwardRef(function SendAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SendAlt.propTypes = iconPropTypes;
}
const SendAltFilled = /*#__PURE__*/React.forwardRef(function SendAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SendAltFilled.propTypes = iconPropTypes;
}
const SendFilled = /*#__PURE__*/React.forwardRef(function SendFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SendFilled.propTypes = iconPropTypes;
}
const SendActionUsage = /*#__PURE__*/React.forwardRef(function SendActionUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,21c-.5523,0-1-.4477-1-1v-8c0-.5523.4477-1,1-1h11.1716c.5304,0,1.0391.2107,1.4142.5858l4.4142,4.4142-4.4142,4.4142c-.3751.3751-.8838.5858-1.4142.5858h-11.1715Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SendActionUsage.propTypes = iconPropTypes;
}
const SendBackward = /*#__PURE__*/React.forwardRef(function SendBackward({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M4,7H2V4A2.0023,2.0023,0,0,1,4,2H7V4H4Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M7,22H4a2.0023,2.0023,0,0,1-2-2V17H4v3H7Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H4V14H2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M22,7H20V4H17V2h3a2.0023,2.0023,0,0,1,2,2Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H14V4H10z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H12a2.0023,2.0023,0,0,1-2-2V12a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM12,12V28H28V12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SendBackward.propTypes = iconPropTypes;
}
const SendToBack = /*#__PURE__*/React.forwardRef(function SendToBack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SendToBack.propTypes = iconPropTypes;
}
const ServerDns = /*#__PURE__*/React.forwardRef(function ServerDns({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,2Zm5.91,7H19.4724a15.2457,15.2457,0,0,0-.7917-4.36A6.0088,6.0088,0,0,1,21.91,9ZM16.022,15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952,14.1763,16.3711,15.877,16.022,15.999ZM14.5354,9c.1694-3.1763,1.0935-4.877,1.4426-4.999h.0076c.3813.1206,1.3091,1.8213,1.479,4.999ZM13.3193,4.64A15.2457,15.2457,0,0,0,12.5276,9H10.09A6.0088,6.0088,0,0,1,13.3193,4.64ZM10.09,11h2.4373a15.2457,15.2457,0,0,0,.7917,4.36A6.0088,6.0088,0,0,1,10.09,11Zm8.59,4.36A15.2457,15.2457,0,0,0,19.4724,11H21.91A6.0088,6.0088,0,0,1,18.6807,15.36Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ServerDns.propTypes = iconPropTypes;
}
const ServerProxy = /*#__PURE__*/React.forwardRef(function ServerProxy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "25",
    r: "1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ServerProxy.propTypes = iconPropTypes;
}
const ServerTime = /*#__PURE__*/React.forwardRef(function ServerTime({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ServerTime.propTypes = iconPropTypes;
}
const ServiceDesk = /*#__PURE__*/React.forwardRef(function ServiceDesk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
    transform: "translate(0 .005)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ServiceDesk.propTypes = iconPropTypes;
}
const ServiceId = /*#__PURE__*/React.forwardRef(function ServiceId({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24v-2h-2.101c-0.13-0.637-0.384-1.229-0.732-1.753l1.49-1.49l-1.414-1.414l-1.49,1.49 c-0.524-0.348-1.116-0.602-1.753-0.732V16h-2v2.101c-0.637,0.13-1.229,0.384-1.753,0.732l-1.49-1.49l-1.414,1.414l1.49,1.49 c-0.348,0.524-0.602,1.116-0.732,1.753H16v2h2.101c0.13,0.637,0.384,1.229,0.732,1.753l-1.49,1.49l1.414,1.414l1.49-1.49 c0.524,0.348,1.116,0.602,1.753,0.732V30h2v-2.101c0.637-0.13,1.229-0.384,1.753-0.732l1.49,1.49l1.414-1.414l-1.49-1.49 c0.348-0.524,0.602-1.116,0.732-1.753H30z M23,26c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S24.654,26,23,26z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H16V8H12z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ServiceId.propTypes = iconPropTypes;
}
const ServiceLevels = /*#__PURE__*/React.forwardRef(function ServiceLevels({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "19",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "19",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "14",
    r: "1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m30,20h-2c0-1.2616-.1946-2.5042-.5786-3.6929l1.9033-.6146c.448,1.3876.6753,2.8369.6753,4.3075Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m29.8508,8.9775l-2.4368,2.4365-.0005-.0005c-.3621.3623-.8621.5864-1.4136.5864-1.103,0-2-.897-2-2,0-.5518.2241-1.0518.5864-1.4136l-.0005-.0005,2.4368-2.4365c-.3284-.0879-.667-.1494-1.0227-.1494-2.2056,0-4,1.7944-4,4,0,.7393.2153,1.4238.5669,2.019l-4.5479,4.5479c-.595-.3516-1.2795-.5669-2.019-.5669-2.2056,0-4,1.7944-4,4s1.7944,4,4,4,4-1.7944,4-4c0-.7397-.2153-1.4243-.5669-2.019l4.5479-4.5479c.595.3516,1.2795.5669,2.019.5669,2.2056,0,4-1.7944,4-4,0-.3555-.0615-.6943-.1492-1.0225Zm-13.8508,13.0225c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m4,20h-2c0-7.7196,6.2803-14,14-14,1.4707,0,2.9199.2272,4.3074.6754l-.6147,1.9031c-1.1885-.3838-2.4309-.5785-3.6926-.5785-6.6167,0-12,5.3832-12,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ServiceLevels.propTypes = iconPropTypes;
}
const SessionBorderControl = /*#__PURE__*/React.forwardRef(function SessionBorderControl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SessionBorderControl.propTypes = iconPropTypes;
}
const Settings = /*#__PURE__*/React.forwardRef(function Settings({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
      d: "M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3 c-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1 C5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4 c0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8 L9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6 C5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z"
    })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
      d: "M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8 c0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Settings.propTypes = iconPropTypes;
}
const SettingsAdjust = /*#__PURE__*/React.forwardRef(function SettingsAdjust({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8h-4.1c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2v2h14.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30V8z M21,12c-1.7,0-3-1.3-3-3 s1.3-3,3-3s3,1.3,3,3S22.7,12,21,12z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M2,24h4.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30v-2H15.9c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2V24z M11,20c1.7,0,3,1.3,3,3 s-1.3,3-3,3s-3-1.3-3-3S9.3,20,11,20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SettingsAdjust.propTypes = iconPropTypes;
}
const SettingsCheck = /*#__PURE__*/React.forwardRef(function SettingsCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SettingsCheck.propTypes = iconPropTypes;
}
const SettingsEdit = /*#__PURE__*/React.forwardRef(function SettingsEdit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m31.707,19.2929l-3-3c-.3906-.3906-1.0234-.3906-1.4141,0l-9.293,9.293v4.4141h4.4141l9.293-9.293c.3906-.3906.3906-1.0234,0-1.4141Zm-10.1211,8.707h-1.5859v-1.5859l5-5,1.5859,1.5859-5,5Zm6.4141-6.4141l-1.5859-1.5859,1.5859-1.5859,1.5859,1.5859-1.5859,1.5859Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m16,22c-3.3643,0-6-2.6357-6-6s2.6357-6,6-6,6,2.6357,6,6-2.6357,6-6,6Zm0-10c-2.2803,0-4,1.7197-4,4s1.7197,4,4,4,4-1.7197,4-4-1.7197-4-4-4Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m27.5474,12.0005l1.7322-1-2.3354-4.0444c-.3652-.6328-1.0334-1.0005-1.7322-1.0005-.2134,0-.4294.0342-.6406.106l-2.4341.8232c-.418-.2812-.856-.5352-1.312-.7583l-.5037-2.5186c-.187-.9351-1.0078-1.6079-1.9612-1.6079h-4.7207c-.9534,0-1.7742.6729-1.9612,1.6079l-.5037,2.5186c-.459.2246-.9062.4692-1.3267.7534l-2.4194-.8184c-.2112-.0718-.4272-.106-.6406-.106-.6987,0-1.3669.3677-1.7322,1.0005l-2.3606,4.0879c-.4766.8257-.3042,1.873.4119,2.5024l1.9309,1.6968c-.0171.2515-.0381.5015-.0381.7568,0,.2578.0103.5127.0278.7656l-1.9207,1.688c-.7161.6294-.8884,1.6768-.4119,2.5024l2.3606,4.0879c.3652.6328,1.0334,1.0005,1.7322,1.0005.2134,0,.4297-.0342.6406-.106l2.4341-.8232c.418.2817.856.5352,1.312.7583l.5037,2.5186c.187.9351,1.0078,1.6079,1.9612,1.6079h2.3604v-2h-2.3604l-.7102-3.5508c-.9753-.356-1.9026-.9062-2.6948-1.5713l-3.4468,1.166-2.3604-4.0879,2.7253-2.395c-.1838-1.043-.1914-2.083-.0071-3.1279l-2.7183-2.3892,2.3611-4.0879,3.4268,1.1592c.8032-.6763,1.7295-1.2051,2.7141-1.5645l.7102-3.5508h4.7207l.7102,3.5508c.9753.356,1.9023.9062,2.6948,1.5713l3.4468-1.166,2.3352,4.0444Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SettingsEdit.propTypes = iconPropTypes;
}
const SettingsServices = /*#__PURE__*/React.forwardRef(function SettingsServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H18a1,1,0,0,1-1-1V23a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,24,30Zm-5-2h4V24H19Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M15,19.8579A3.9934,3.9934,0,1,1,20,16h2a6,6,0,1,0-7,5.91Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SettingsServices.propTypes = iconPropTypes;
}
const SettingsView = /*#__PURE__*/React.forwardRef(function SettingsView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7769,23.4785A8.64,8.64,0,0,0,23,18a8.64,8.64,0,0,0-7.7769,5.4785L15,24l.2231.5215A8.64,8.64,0,0,0,23,30a8.64,8.64,0,0,0,7.7769-5.4785L31,24ZM23,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,23,28Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3989,20.8A6,6,0,1,1,22,16H20a4,4,0,1,0-6.4,3.2Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SettingsView.propTypes = iconPropTypes;
}
const ShapeExcept = /*#__PURE__*/React.forwardRef(function ShapeExcept({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShapeExcept.propTypes = iconPropTypes;
}
const ShapeExclude = /*#__PURE__*/React.forwardRef(function ShapeExclude({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShapeExclude.propTypes = iconPropTypes;
}
const ShapeIntersect = /*#__PURE__*/React.forwardRef(function ShapeIntersect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShapeIntersect.propTypes = iconPropTypes;
}
const ShapeJoin = /*#__PURE__*/React.forwardRef(function ShapeJoin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShapeJoin.propTypes = iconPropTypes;
}
const ShapeUnite = /*#__PURE__*/React.forwardRef(function ShapeUnite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShapeUnite.propTypes = iconPropTypes;
}
const Shapes = /*#__PURE__*/React.forwardRef(function Shapes({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m5,16h-2v11c0,1.1045.8954,2,2,2h8v-2H5v-11Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,29h-11c-.3535,0-.6809-.1866-.8608-.4911-.0927-.1568-.1392-.3328-.1392-.5089,0-.1658.0412-.3317.1238-.4819l5.5-10c.1898-.3451.5333-.5178.8762-.5181.3434-.0003.6861.1724.8762.5181l5.5,10c.0826.1502.1238.3162.1238.4819,0,.1762-.0465.3521-.1392.5089-.1799.3044-.5073.4911-.8608.4911Zm-9.3088-2h7.6177l-3.8088-6.9249-3.8088,6.9249Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,3h-11v2h11v13.9922h2V5c0-1.1045-.8954-2-2-2Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11,3h-6c-1.1046,0-2,.8955-2,2v6c0,1.1045.8954,2,2,2h6c1.1046,0,2-.8955,2-2v-6c0-1.1045-.8954-2-2-2Zm0,8h-6v-6h6v6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Shapes.propTypes = iconPropTypes;
}
const Share = /*#__PURE__*/React.forwardRef(function Share({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Share.propTypes = iconPropTypes;
}
const ShareKnowledge = /*#__PURE__*/React.forwardRef(function ShareKnowledge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M27,25H21a3,3,0,0,0-3,3v2h2V28a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V28A3,3,0,0,0,27,25Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20a4,4,0,1,0,4-4A4,4,0,0,0,20,20Zm6,0a2,2,0,1,1-2-2A2,2,0,0,1,26,20Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M6,21V20H4v1a7,7,0,0,0,7,7h3V26H11A5,5,0,0,1,6,21Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10H26V12H19z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6H29V8H19z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H29V4H19z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11H5a3,3,0,0,0-3,3v2H4V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V14A3,3,0,0,0,11,11Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10A4,4,0,1,0,4,6,4,4,0,0,0,8,10ZM8,4A2,2,0,1,1,6,6,2,2,0,0,1,8,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShareKnowledge.propTypes = iconPropTypes;
}
const ShoppingBag = /*#__PURE__*/React.forwardRef(function ShoppingBag({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingBag.propTypes = iconPropTypes;
}
const ShoppingCart = /*#__PURE__*/React.forwardRef(function ShoppingCart({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCart.propTypes = iconPropTypes;
}
const ShoppingCartArrowDown = /*#__PURE__*/React.forwardRef(function ShoppingCartArrowDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCartArrowDown.propTypes = iconPropTypes;
}
const ShoppingCartArrowUp = /*#__PURE__*/React.forwardRef(function ShoppingCartArrowUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCartArrowUp.propTypes = iconPropTypes;
}
const ShoppingCartClear = /*#__PURE__*/React.forwardRef(function ShoppingCartClear({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCartClear.propTypes = iconPropTypes;
}
const ShoppingCartError = /*#__PURE__*/React.forwardRef(function ShoppingCartError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCartError.propTypes = iconPropTypes;
}
const ShoppingCartMinus = /*#__PURE__*/React.forwardRef(function ShoppingCartMinus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L12 8 22 8 22 6 12 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCartMinus.propTypes = iconPropTypes;
}
const ShoppingCartPlus = /*#__PURE__*/React.forwardRef(function ShoppingCartPlus({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCartPlus.propTypes = iconPropTypes;
}
const ShoppingCatalog = /*#__PURE__*/React.forwardRef(function ShoppingCatalog({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H21V28H17z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H28V28H24z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H21V21H17z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17H28V21H24z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2 H6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShoppingCatalog.propTypes = iconPropTypes;
}
const ShowDataCards = /*#__PURE__*/React.forwardRef(function ShowDataCards({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H4A2.0022,2.0022,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V8A2.0022,2.0022,0,0,1,28,10ZM4,4V8H28V4Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0022,2.0022,0,0,1-2-2V24a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v4A2.0022,2.0022,0,0,1,28,30ZM4,24v4H28V24Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0022,2.0022,0,0,1-2-2V14a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v4A2.0022,2.0022,0,0,1,28,20ZM4,14v4H28V14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShowDataCards.propTypes = iconPropTypes;
}
const ShrinkScreen = /*#__PURE__*/React.forwardRef(function ShrinkScreen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H17a2.0023,2.0023,0,0,1-2-2V20a2.0023,2.0023,0,0,1,2-2H28a2.0027,2.0027,0,0,1,2,2v6A2.0027,2.0027,0,0,1,28,28ZM17,20v6H28.002L28,20Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShrinkScreen.propTypes = iconPropTypes;
}
const ShrinkScreenFilled = /*#__PURE__*/React.forwardRef(function ShrinkScreenFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "10",
    x: "15",
    y: "18",
    rx: "2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ShrinkScreenFilled.propTypes = iconPropTypes;
}
const Shuffle = /*#__PURE__*/React.forwardRef(function Shuffle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Shuffle.propTypes = iconPropTypes;
}
const Shuttle = /*#__PURE__*/React.forwardRef(function Shuttle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Shuttle.propTypes = iconPropTypes;
}
const SidePanelClose = /*#__PURE__*/React.forwardRef(function SidePanelClose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8 l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SidePanelClose.propTypes = iconPropTypes;
}
const SidePanelCloseFilled = /*#__PURE__*/React.forwardRef(function SidePanelCloseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6 l1.4-1.4L17.8,17H28v9H12V6h16V15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SidePanelCloseFilled.propTypes = iconPropTypes;
}
const SidePanelOpen = /*#__PURE__*/React.forwardRef(function SidePanelOpen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2 l-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SidePanelOpen.propTypes = iconPropTypes;
}
const SidePanelOpenFilled = /*#__PURE__*/React.forwardRef(function SidePanelOpenFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22 l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SidePanelOpenFilled.propTypes = iconPropTypes;
}
const Sight = /*#__PURE__*/React.forwardRef(function Sight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12V14H10z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8V14H6z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H4V14H2z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sight.propTypes = iconPropTypes;
}
const Sigma = /*#__PURE__*/React.forwardRef(function Sigma({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sigma.propTypes = iconPropTypes;
}
const SignalStrength = /*#__PURE__*/React.forwardRef(function SignalStrength({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H28V26H26z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H20V26H18z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V26H11z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20H6V26H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SignalStrength.propTypes = iconPropTypes;
}
const SimCard = /*#__PURE__*/React.forwardRef(function SimCard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SimCard.propTypes = iconPropTypes;
}
const SkillLevel = /*#__PURE__*/React.forwardRef(function SkillLevel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Zm-6-2h4V6H24Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Zm-6-2h4V14H14Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8ZM4,28H8V20H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkillLevel.propTypes = iconPropTypes;
}
const SkillLevelAdvanced = /*#__PURE__*/React.forwardRef(function SkillLevelAdvanced({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkillLevelAdvanced.propTypes = iconPropTypes;
}
const SkillLevelBasic = /*#__PURE__*/React.forwardRef(function SkillLevelBasic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Zm-6-2h4V6H24Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Zm-6-2h4V14H14Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkillLevelBasic.propTypes = iconPropTypes;
}
const SkillLevelIntermediate = /*#__PURE__*/React.forwardRef(function SkillLevelIntermediate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V4h8Zm-6-2h4V6H24Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H12V12h8Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H2V18h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkillLevelIntermediate.propTypes = iconPropTypes;
}
const SkipBack = /*#__PURE__*/React.forwardRef(function SkipBack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28a1,1,0,0,1-.5-.13l-19-11a1,1,0,0,1,0-1.74l19-11a1,1,0,0,1,1,0A1,1,0,0,1,28,5V27a1,1,0,0,1-1,1ZM10,16l16,9.27V6.73Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H4V28H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipBack.propTypes = iconPropTypes;
}
const SkipBackFilled = /*#__PURE__*/React.forwardRef(function SkipBackFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28a.9975.9975,0,0,1-.501-.1348l-19-11a1,1,0,0,1,0-1.73l19-11A1,1,0,0,1,28,5V27a1,1,0,0,1-1,1Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H4V28H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipBackFilled.propTypes = iconPropTypes;
}
const SkipBackOutline = /*#__PURE__*/React.forwardRef(function SkipBackOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V22H9z",
    transform: "rotate(-180 10 16)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipBackOutline.propTypes = iconPropTypes;
}
const SkipBackOutlineFilled = /*#__PURE__*/React.forwardRef(function SkipBackOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.301L22 12.699 16.059 16 22 19.301z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H10V22H8z",
    transform: "rotate(-180 9 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipBackOutlineFilled.propTypes = iconPropTypes;
}
const SkipBackOutlineSolid = /*#__PURE__*/React.forwardRef(function SkipBackOutlineSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V22H9z",
    transform: "rotate(-180 10 16)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipBackOutlineSolid.propTypes = iconPropTypes;
}
const SkipBackSolidFilled = /*#__PURE__*/React.forwardRef(function SkipBackSolidFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H10V22H8z",
    transform: "rotate(-180 9 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipBackSolidFilled.propTypes = iconPropTypes;
}
const SkipForward = /*#__PURE__*/React.forwardRef(function SkipForward({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M5,28a1,1,0,0,1-1-1V5a1,1,0,0,1,.5-.87,1,1,0,0,1,1,0l19,11a1,1,0,0,1,0,1.74l-19,11A1,1,0,0,1,5,28ZM6,6.73V25.27L22,16Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H30V28H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForward.propTypes = iconPropTypes;
}
const SkipForwardFilled = /*#__PURE__*/React.forwardRef(function SkipForwardFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H30V28H28z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M5,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.501-.8652l19,11a1,1,0,0,1,0,1.73l-19,11A.9975.9975,0,0,1,5,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardFilled.propTypes = iconPropTypes;
}
const SkipForwardOutline = /*#__PURE__*/React.forwardRef(function SkipForwardOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H23V22H21z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8742l9,5a1,1,0,0,1,0,1.7485l-9,5a1.0009,1.0009,0,0,1-.9931-.0125ZM10,12.7v6.6011L15.9409,16Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardOutline.propTypes = iconPropTypes;
}
const SkipForwardOutlineFilled = /*#__PURE__*/React.forwardRef(function SkipForwardOutlineFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.301L15.941 16 10 12.699 10 19.301z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22 10H24V22H22z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8743l9,5a1,1,0,0,1,0,1.7486l-9,5a1.0009,1.0009,0,0,1-.9931-.0125ZM10,12.7v6.601L15.9409,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardOutlineFilled.propTypes = iconPropTypes;
}
const SkipForwardOutlineSolid = /*#__PURE__*/React.forwardRef(function SkipForwardOutlineSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H23V22H21z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8742l9,5a1,1,0,0,1,0,1.7485l-9,5a1.0009,1.0009,0,0,1-.9931-.0125Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardOutlineSolid.propTypes = iconPropTypes;
}
const SkipForwardSolidFilled = /*#__PURE__*/React.forwardRef(function SkipForwardSolidFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm2.4858,14.874-9,5A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.874l9,5a1,1,0,0,1,0,1.748ZM24,22H22V10h2Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22 10H24V22H22z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.4927,21.8618A1,1,0,0,1,8,21V11a1,1,0,0,1,1.4858-.8743l9,5a1,1,0,0,1,0,1.7486l-9,5a1.0009,1.0009,0,0,1-.9931-.0125Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SkipForwardSolidFilled.propTypes = iconPropTypes;
}
const Sleet = /*#__PURE__*/React.forwardRef(function Sleet({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H8V26H6z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H10V28H8z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M10 28H12V30H10z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H12V26H10z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28H8V30H6z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,21,30Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22h8.8818L16.106,24.5527a1,1,0,1,0,1.7885.8946L19.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Sleet.propTypes = iconPropTypes;
}
const Slisor = /*#__PURE__*/React.forwardRef(function Slisor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a1.0005,1.0005,0,0,1-.4473-.1055l-10-5,.8946-1.789L16,19.8821l9.5527-4.7766.8946,1.789-10,5A1.0005,1.0005,0,0,1,16,22Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a1.0005,1.0005,0,0,1-.4473-.1055l-10-5a1,1,0,0,1,0-1.789l10-5a1.0008,1.0008,0,0,1,.8946,0l10,5a1,1,0,0,1,0,1.789l-10,5A1.0005,1.0005,0,0,1,16,16ZM8.2358,10,16,13.8821,23.7642,10,16,6.1179Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Slisor.propTypes = iconPropTypes;
}
const Slm = /*#__PURE__*/React.forwardRef(function Slm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L26.5 14 26 16 25.5 14 24 9 22 9 22 23 24 23 24 15 23.8 13 24.4 15 26 19.6 27.6 15 28.2 13 28 15 28 23 30 23 30 9z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L14 9 12 9 12 23 20 23 20 21z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M8,23H2v-2h6v-4H4c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h6v2H4v4h4c1.1,0,2,0.9,2,2v4C10,22.1,9.1,23,8,23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Slm.propTypes = iconPropTypes;
}
const Smell = /*#__PURE__*/React.forwardRef(function Smell({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M22,15V10H20v7h2a3,3,0,0,1,0,6H21V21H19v2a3,3,0,0,1-6,0V21H11v2H10a3,3,0,0,1,0-6h2V9a3,3,0,0,1,3-3h1V4H15a5,5,0,0,0-5,5v6a5,5,0,0,0,0,10h1.42a5,5,0,0,0,9.16,0H22a5,5,0,0,0,0-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Smell.propTypes = iconPropTypes;
}
const Smoke = /*#__PURE__*/React.forwardRef(function Smoke({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M27.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L23.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L27.8,26.4A1,1,0,0,1,27.001,28Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M22.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L18.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L22.8,26.4A1,1,0,0,1,22.001,28Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M17.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762a6.9956,6.9956,0,0,0-1.2446-5.6668L13.2,5.6a1,1,0,1,1,1.6-1.2l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L17.8,26.4A1,1,0,0,1,17.001,28Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001,28a.998.998,0,0,1-.8008-.4l-.8145-1.086a8.9976,8.9976,0,0,1-1.6005-7.2856l1.4736-6.8762A6.9956,6.9956,0,0,0,9.0142,6.6855L8.2,5.6A1,1,0,1,1,9.8,4.4l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856l-1.4736,6.8762a6.9956,6.9956,0,0,0,1.2446,5.6668L12.8,26.4A1,1,0,0,1,12.001,28Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M7.001,28A.998.998,0,0,1,6.2,27.6l-.8145-1.086a8.9976,8.9976,0,0,1-1.6-7.2856l1.4736-6.8762A6.9956,6.9956,0,0,0,4.0142,6.6855L3.2,5.6A1,1,0,1,1,4.8,4.4l.8145,1.0857a8.9976,8.9976,0,0,1,1.6005,7.2856L5.7412,19.6474a6.9956,6.9956,0,0,0,1.2446,5.6668L7.8,26.4A1,1,0,0,1,7.001,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Smoke.propTypes = iconPropTypes;
}
const WatsonHealthSmoothing = /*#__PURE__*/React.forwardRef(function WatsonHealthSmoothing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "5"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7,4.7a14.7029,14.7029,0,0,0-3,3.1L6.3,9A13.2634,13.2634,0,0,1,8.9,6.3Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,12.3l-1.9-.6A12.5111,12.5111,0,0,0,2,16H4A11.4756,11.4756,0,0,1,4.6,12.3Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,20.4a14.4029,14.4029,0,0,0,2,3.9l1.6-1.2a12.8867,12.8867,0,0,1-1.7-3.3Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8,27.3a14.4029,14.4029,0,0,0,3.9,2l.6-1.9A12.8867,12.8867,0,0,1,9,25.7Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7,2.7l.6,1.9A11.4756,11.4756,0,0,1,16,4V2A12.5111,12.5111,0,0,0,11.7,2.7Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.526,11.526,0,0,1,23,25.7Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,19.7l1.9.6A15.4747,15.4747,0,0,0,30,16H28A11.4756,11.4756,0,0,1,27.4,19.7Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2,11.6a14.4029,14.4029,0,0,0-2-3.9L25.6,8.9a12.8867,12.8867,0,0,1,1.7,3.3Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,4.6a14.4029,14.4029,0,0,0-3.9-2l-.6,1.9a12.8867,12.8867,0,0,1,3.3,1.7Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,29.3l-.6-1.9A11.4756,11.4756,0,0,1,16,28v2A21.4206,21.4206,0,0,0,20.3,29.3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSmoothing.propTypes = iconPropTypes;
}
const WatsonHealthSmoothingCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthSmoothingCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "4"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30a11.8932,11.8932,0,0,1-4.1035-.72L14.58,27.4A9.9725,9.9725,0,0,0,18,28Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1484,29.2637l-.6914-1.877a9.9556,9.9556,0,0,0,2.9973-1.748l1.2916,1.5268A11.9525,11.9525,0,0,1,22.1484,29.2637Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2893,27.1951A12.0141,12.0141,0,0,1,7.61,24.0078l1.73-1.0029a10.0236,10.0236,0,0,0,2.2347,2.6584Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4133,23.967l-1.7343-.9956a9.9159,9.9159,0,0,0,1.176-3.2641l1.9712.3388A11.8956,11.8956,0,0,1,28.4133,23.967Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1821,20.0925A12.1282,12.1282,0,0,1,6.1777,15.93l1.9707.3423a10.1214,10.1214,0,0,0,.0035,3.4738Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8447,16.2339a9.9019,9.9019,0,0,0-1.1953-3.2564l1.7285-1.0063a11.9029,11.9029,0,0,1,1.4361,3.9121Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3313,13.0107l-1.7324-.999a12.01,12.01,0,0,1,2.6738-3.1931l1.2886,1.53A10.01,10.01,0,0,0,9.3313,13.0107Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4094,10.3237a9.96,9.96,0,0,0-3.0088-1.7309l.68-1.8809a11.9491,11.9491,0,0,1,3.6118,2.0772Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M14.562,8.6064l-.6875-1.8779A12.1031,12.1031,0,0,1,18,6V8A10.0875,10.0875,0,0,0,14.562,8.6064Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthSmoothingCursor.propTypes = iconPropTypes;
}
const Snooze = /*#__PURE__*/React.forwardRef(function Snooze({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14L20 12 12 12 12 14 17.5 14 12 20 12 22 20 22 20 20 14.507 20 20 14z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.965H26.499V9.036999999999999H24.5z",
    transform: "rotate(-44.945 25.5 6.5)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11.0125,11.0125,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9.01,9.01,0,0,0,16,8Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M3.965 5.501H9.036999999999999V7.5H3.965z",
    transform: "rotate(-45.055 6.5 6.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Snooze.propTypes = iconPropTypes;
}
const Snow = /*#__PURE__*/React.forwardRef(function Snow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22ZM16,4a7,7,0,0,0-6.94,6.14L9,11,8.14,11a4.5,4.5,0,0,0,.36,9h15a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82A7,7,0,0,0,16,4Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.05L10.95 24 9.5 25.45 8.05 24 7 25.05 8.45 26.5 7 27.95 8.05 29 9.5 27.55 10.95 29 12 27.95 10.55 26.5 12 25.05z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25.05L24.95 24 23.5 25.45 22.05 24 21 25.05 22.45 26.5 21 27.95 22.05 29 23.5 27.55 24.95 29 26 27.95 24.55 26.5 26 25.05z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27.05L17.95 26 16.5 27.45 15.05 26 14 27.05 15.45 28.5 14 29.95 15.05 31 16.5 29.55 17.95 31 19 29.95 17.55 28.5 19 27.05z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Snow.propTypes = iconPropTypes;
}
const SnowBlizzard = /*#__PURE__*/React.forwardRef(function SnowBlizzard({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H15V12H13z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V14H15z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H19V16H17z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H19V12H17z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14H15V16H13z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M3 26H5V28H3z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28H7V30H5z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30H9V32H7z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26H9V28H7z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M3 30H5V32H3z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V28H23z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28H27V30H25z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30H29V32H27z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26H29V28H27z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30H25V32H23z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H10V20H8z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H12V22H10z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22H14V24H12z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H14V20H12z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H10V24H8z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H20V20H18z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H24V24H22z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H24V20H22z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26H15V28H13z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28H17V30H15z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30H19V32H17z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26H19V28H17z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30H15V32H13z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowBlizzard.propTypes = iconPropTypes;
}
const SnowHeavy = /*#__PURE__*/React.forwardRef(function SnowHeavy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H6V28H4z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28H8V30H6z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30H10V32H8z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H10V28H8z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30H6V32H4z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H10V20H8z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H12V22H10z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22H14V24H12z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H14V20H12z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H10V24H8z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H20V20H18z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22H24V24H22z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H24V20H22z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26H16V28H14z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H18V30H16z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30H20V32H18z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H20V28H18z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H16V32H14z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4957,6.4957,0,0,0,6,21.4985v-2.26A4.4943,4.4943,0,0,1,8.144,11.019l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4944,4.4944,0,0,1,26,19.2383v2.26A6.4958,6.4958,0,0,0,24.8008,9.1362Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowHeavy.propTypes = iconPropTypes;
}
const SnowScattered = /*#__PURE__*/React.forwardRef(function SnowScattered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H4V28H2z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H6V30H4z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H8V32H6z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H8V28H6z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30H4V32H2z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H22V28H20z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H24V30H22z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H26V32H24z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30H22V32H20z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26H13V28H11z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H15V30H13z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H17V32H15z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30H13V32H11z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10.001H32V12.001H29z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 16.233H29.732V18.233H26.732z",
    transform: "rotate(-135 28.232 17.233)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M12.268 3.768H15.268V5.768H12.268z",
    transform: "rotate(-135 13.768 4.768)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9852,5.9852,0,0,0,16.1431,7.5083,7.3737,7.3737,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a5.9672,5.9672,0,0,0,5.5667-8.2A5.9722,5.9722,0,0,0,27,11ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm4.5222-7.9131a5.9592,5.9592,0,0,0-2.8728-1.8428,7.5212,7.5212,0,0,0-2.7224-3.78,3.9869,3.9869,0,1,1,5.5952,5.6225Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowScattered.propTypes = iconPropTypes;
}
const SnowScatteredNight = /*#__PURE__*/React.forwardRef(function SnowScatteredNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H4V28H2z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28H6V30H4z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H8V32H6z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H8V28H6z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30H4V32H2z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26H22V28H20z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28H24V30H22z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H26V32H24z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30H22V32H20z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M11 26H13V28H11z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H15V30H13z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H17V32H15z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V28H15z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30H13V32H11z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8439,13.0347a1.517,1.517,0,0,0-1.23-.8658,5.3552,5.3552,0,0,1-3.4095-1.7158,6.4655,6.4655,0,0,1-1.286-6.3926,1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.7685,7.7685,0,0,0-5.8847,5.5737A7.3706,7.3706,0,0,0,13.5,7a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,24H19a6.0066,6.0066,0,0,0,6-6c0-.0571-.0123-.1113-.0139-.1685a7.5076,7.5076,0,0,0,4.7611-3.2768A1.5369,1.5369,0,0,0,29.8439,13.0347ZM19,22H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,22Zm5.5974-6.1289a5.9661,5.9661,0,0,0-3.948-3.627,7.49,7.49,0,0,0-2.489-3.58,5.9018,5.9018,0,0,1,3.6381-4.4473,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,14.041,5.4487,5.4487,0,0,1,24.5974,15.8711Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowScatteredNight.propTypes = iconPropTypes;
}
const SnowDensity = /*#__PURE__*/React.forwardRef(function SnowDensity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 16.8L19.4 15.2 17 17 17 14 15 14 15 17 12.6 15.2 11.4 16.8 14.333 19 11.4 21.2 12.6 22.8 15 21 15 24 17 24 17 21 19.4 22.8 20.6 21.2 17.667 19 20.6 16.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SnowDensity.propTypes = iconPropTypes;
}
const Snowflake = /*#__PURE__*/React.forwardRef(function Snowflake({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4148,12H28V10H23.4148l4.5857-4.5854L26.5864,4,22,8.5869V4H20v6.5869L18.5867,12H17V8H15v4H13.4133L12,10.5869V4H10V8.5869L5.4136,4,4,5.4146,8.5852,10H4v2h6.5852L12,13.415V15H8v2h4v1.5869L10.5867,20H4v2H8.5867L4,26.5864l1.4141,1.4141L10,23.415V28h2V21.415L13.4148,20H15v4h2V20h1.5852L20,21.415V28h2V23.415l4.5854,4.5855L28,26.5864,23.4133,22H28V20H21.4133L20,18.5869V17h4V15H20V13.415ZM18,18H14V14h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Snowflake.propTypes = iconPropTypes;
}
const Soccer = /*#__PURE__*/React.forwardRef(function Soccer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "28",
    r: "2"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55 17.5H15.45V19.5H7.55z",
    transform: "rotate(-45 11.5 18.5)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16.584,19.4143,8H6v2H18.5857l3,3L6,28.5859,7.4141,30,23,14.415,26.584,18,23,21.5859,24.4141,23,28,19.416A2.0044,2.0044,0,0,0,28,16.584Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,9A3.5,3.5,0,1,1,28,5.5,3.504,3.504,0,0,1,24.5,9Zm0-5A1.5,1.5,0,1,0,26,5.5,1.5017,1.5017,0,0,0,24.5,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Soccer.propTypes = iconPropTypes;
}
const SoftwareResource = /*#__PURE__*/React.forwardRef(function SoftwareResource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoftwareResource.propTypes = iconPropTypes;
}
const SoftwareResourceCluster = /*#__PURE__*/React.forwardRef(function SoftwareResourceCluster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21c-0.5,0-1-0.2-1.4-0.6l-3-3C19.2,17,19,16.5,19,16s0.2-1,0.6-1.4l3-3C23,11.2,23.5,11,24,11c0.5,0,1,0.2,1.4,0.6l3,3 C28.8,15,29,15.5,29,16c0,0.5-0.2,1-0.6,1.4l-3,3C25,20.8,24.5,21,24,21z M24,13l-3,3l3,3l3-3L24,13z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13c-0.5,0-1-0.2-1.4-0.6l-3-3C11.2,9,11,8.5,11,8s0.2-1,0.6-1.4l3-3C15,3.2,15.5,3,16,3c0.5,0,1,0.2,1.4,0.6l3,3 C20.8,7,21,7.5,21,8c0,0.5-0.2,1-0.6,1.4l-3,3C17,12.8,16.5,13,16,13z M16,5l-3,3l3,3l3-3L16,5z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M16,29c-0.5,0-1-0.2-1.4-0.6l-3-3C11.2,25,11,24.5,11,24s0.2-1,0.6-1.4l3-3C15,19.2,15.5,19,16,19c0.5,0,1,0.2,1.4,0.6l3,3 C20.8,23,21,23.5,21,24c0,0.5-0.2,1-0.6,1.4l-3,3C17,28.8,16.5,29,16,29z M16,21l-3,3l3,3l3-3L16,21z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M8,21c-0.5,0-1-0.2-1.4-0.6l-3-3C3.2,17,3,16.5,3,16s0.2-1,0.6-1.4l3-3C7,11.2,7.5,11,8,11c0.5,0,1,0.2,1.4,0.6l3,3 C12.8,15,13,15.5,13,16c0,0.5-0.2,1-0.6,1.4l-3,3C9,20.8,8.5,21,8,21z M8,13l-3,3l3,3l3-3L8,13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoftwareResourceCluster.propTypes = iconPropTypes;
}
const SoftwareResourceResource = /*#__PURE__*/React.forwardRef(function SoftwareResourceResource({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 8.3H11.7V10.3H6.9z",
    transform: "rotate(-45.001 9.293 9.293)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9,19.7l-2.3-2.3C2.2,17,2,16.5,2,16s0.2-1,0.6-1.4l2.3-2.3l1.4,1.4L4,16l2.3,2.3L4.9,19.7z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 20.3H10.3V25.1H8.3z",
    transform: "rotate(-45.001 9.293 22.707)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-0.5,0-1-0.2-1.4-0.6l-2.3-2.3l1.4-1.4L16,28l2.3-2.3l1.4,1.4l-2.3,2.3C17,29.8,16.5,30,16,30z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 21.7H25.1V23.7H20.3z",
    transform: "rotate(-45.001 22.707 22.707)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1,19.7l-1.4-1.4L28,16l-2.3-2.3l1.4-1.4l2.3,2.3C29.8,15,30,15.5,30,16s-0.2,1-0.6,1.4L27.1,19.7z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 6.9H23.7V11.7H21.7z",
    transform: "rotate(-45.001 22.707 9.293)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2c-0.5,0-1,0.2-1.4,0.6l-2.3,2.3l1.4,1.4L16,4l2.3,2.3l1.4-1.4l-2.3-2.3C17,2.2,16.5,2,16,2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoftwareResourceResource.propTypes = iconPropTypes;
}
const SoilMoisture = /*#__PURE__*/React.forwardRef(function SoilMoisture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,28A5.385,5.385,0,0,1,19,22.751a5.3837,5.3837,0,0,1,.874-2.8308L23.49,14.5383a1.217,1.217,0,0,1,2.02,0L29.06,19.8154A5.4923,5.4923,0,0,1,30,22.751,5.385,5.385,0,0,1,24.5,28Zm0-11.38-2.9356,4.3672A3.3586,3.3586,0,0,0,21,22.751a3.51,3.51,0,0,0,7,0,3.4356,3.4356,0,0,0-.63-1.867Z"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "13",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "19",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "25",
    r: "1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "15",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "11",
    r: "1"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "27",
    cy: "11",
    r: "1"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "21",
    r: "1"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H30V8H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilMoisture.propTypes = iconPropTypes;
}
const SoilMoistureField = /*#__PURE__*/React.forwardRef(function SoilMoistureField({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,30a5.202,5.202,0,0,1-4.626-8.08L23.49,16.5382a1.217,1.217,0,0,1,2.02,0L29.06,21.8154A5.4921,5.4921,0,0,1,30,24.751,5.385,5.385,0,0,1,24.5,30Zm0-11.38-2.9356,4.3672A3.2079,3.2079,0,0,0,24.5,28,3.3855,3.3855,0,0,0,28,24.751a3.4354,3.4354,0,0,0-.63-1.867Z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16V11h1a4.0045,4.0045,0,0,0,4-4V4H13a3.9779,3.9779,0,0,0-2.7468,1.1067A6.0034,6.0034,0,0,0,5,2H2V5a6.0066,6.0066,0,0,0,6,6H9v5H2v2H16V16ZM13,6h1V7a2.002,2.002,0,0,1-2,2H11V8A2.002,2.002,0,0,1,13,6ZM8,9A4.0045,4.0045,0,0,1,4,5V4H5A4.0045,4.0045,0,0,1,9,8V9Z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21H16V23H2z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H16V28H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  SoilMoistureField.propTypes = iconPropTypes;
}

export { SatisfyUsage, Save, SaveModel, Scale, Scales, ScalesTipped, Scalpel, Scan, ScanAlt, ScanDisabled, ScatterMatrix, Schematics, ScisControlTower, ScisTransparentSupply, Scooter, ScooterFront, Screen, ScreenMap, ScreenMapSet, ScreenOff, Script, ScriptReference, Sdk, Search, SearchAdvanced, SearchLocate, SearchLocateMirror, Security, SecurityServices, SelectWindow, Select_01, Select_02, Send, SendActionUsage, SendAlt, SendAltFilled, SendBackward, SendFilled, SendToBack, ServerDns, ServerProxy, ServerTime, ServiceDesk, ServiceId, ServiceLevels, SessionBorderControl, Settings, SettingsAdjust, SettingsCheck, SettingsEdit, SettingsServices, SettingsView, ShapeExcept, ShapeExclude, ShapeIntersect, ShapeJoin, ShapeUnite, Shapes, Share, ShareKnowledge, ShoppingBag, ShoppingCart, ShoppingCartArrowDown, ShoppingCartArrowUp, ShoppingCartClear, ShoppingCartError, ShoppingCartMinus, ShoppingCartPlus, ShoppingCatalog, ShowDataCards, ShrinkScreen, ShrinkScreenFilled, Shuffle, Shuttle, SidePanelClose, SidePanelCloseFilled, SidePanelOpen, SidePanelOpenFilled, Sight, Sigma, SignalStrength, SimCard, SkillLevel, SkillLevelAdvanced, SkillLevelBasic, SkillLevelIntermediate, SkipBack, SkipBackFilled, SkipBackOutline, SkipBackOutlineFilled, SkipBackOutlineSolid, SkipBackSolidFilled, SkipForward, SkipForwardFilled, SkipForwardOutline, SkipForwardOutlineFilled, SkipForwardOutlineSolid, SkipForwardSolidFilled, Sleet, Slisor, Slm, Smell, Smoke, Snooze, Snow, SnowBlizzard, SnowDensity, SnowHeavy, SnowScattered, SnowScatteredNight, Snowflake, Soccer, SoftwareResource, SoftwareResourceCluster, SoftwareResourceResource, SoilMoisture, SoilMoistureField, WatsonHealthSaveAnnotation, WatsonHealthSaveImage, WatsonHealthSaveSeries, WatsonHealthScalpelCursor, WatsonHealthScalpelLasso, WatsonHealthScalpelSelect, WatsonHealthSmoothing, WatsonHealthSmoothingCursor };
